import { useState } from "react";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const VerifyForm = ({ email, displayCode, onBack }) => {
  const [codeInput, setCodeInput] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!codeInput.trim()) { setError("Please enter the verification code"); return; }
    setLoading(true);
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const { data } = await axios.post(`${BACKEND_URL}/api/auth/verify-code`, {
        email, code: codeInput.trim(), timezone: tz
      });
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("refresh_token", data.refresh_token);
      window.location.reload();
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid code. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button onClick={onBack} className="flex items-center gap-1 mb-4 text-sm" style={{ color: "var(--color-text-dim)" }}>
        <ArrowLeft className="w-4 h-4" /> Back
      </button>

      <div className="flex items-center gap-3 mb-4">
        <ShieldCheck className="w-8 h-8" style={{ color: "var(--color-accent)" }} />
        <h2 className="text-2xl font-black" style={{ color: "var(--color-text)", fontFamily: "Cabinet Grotesk, sans-serif" }}>
          Verify Your Email
        </h2>
      </div>

      <p className="mb-3" style={{ color: "var(--color-text-muted)" }}>
        A verification code has been generated for <strong style={{ color: "var(--color-text)" }}>{email}</strong>
      </p>

      <div className="mb-6 p-4 rounded-lg text-center" style={{ backgroundColor: "var(--color-accent-glow)", border: "1px solid var(--color-accent)" }}>
        <p className="text-xs mb-1" style={{ color: "var(--color-text-dim)" }}>Your verification code</p>
        <p className="text-3xl font-black tracking-[0.3em]" style={{ color: "var(--color-accent)" }} data-testid="verification-code-display">
          {displayCode}
        </p>
      </div>

      {error && <div className="mb-4 p-3 bg-red-500/10 border border-red-500/30 rounded-lg text-red-400 text-sm" data-testid="verify-error">{error}</div>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2" style={{ color: "var(--color-text-muted)" }}>Enter Code</label>
          <Input type="text" value={codeInput} onChange={(e) => setCodeInput(e.target.value.replace(/\D/g, "").slice(0, 6))}
            placeholder="000000" className="text-center text-2xl tracking-[0.3em] rounded-lg font-bold"
            style={{ backgroundColor: "var(--color-input-bg)", borderColor: "var(--color-border)", color: "var(--color-text)" }}
            data-testid="verification-code-input" maxLength={6} required />
        </div>
        <Button type="submit" disabled={loading || codeInput.length !== 6}
          className="w-full rounded-lg py-3 font-bold text-white"
          style={{ backgroundColor: "var(--color-accent)" }} data-testid="verify-code-button">
          {loading ? "Verifying..." : "Verify & Create Account"}
        </Button>
      </form>
    </>
  );
};

export default VerifyForm;
